import { useEffect, useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import axiosInstance from "../../api/axios";
import "./hackerPass.css";

export default function HackerPass() {
  const [pass, setPass] = useState(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  const qr = useRef(null);
  useEffect(() => {
    let cancelled = false;
    setError("");
    axiosInstance.get("/api/checkin/pass").then(({ data }) => {
      if (!cancelled) setPass(data);
    }).catch(() => {
      if (!cancelled) setError("Unable to load your pass. Please try again.");
    });
    return () => { cancelled = true; };
  }, [attempt]);

  function download() {
    const svg = qr.current.querySelector("svg");
    const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: "image/svg+xml" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = `HackPrinceton-${pass.year}-${pass.cycle}-pass.svg`;
    link.click();
    URL.revokeObjectURL(url);
  }

  return <section className="hacker-pass" aria-labelledby="hacker-pass-title">
    <div>
      <p className="hacker-pass__eyebrow">YOUR EVENT PASS</p>
      <h2 id="hacker-pass-title">My Hacker Pass</h2>
      {pass ? <>
        <h3>{pass.first} {pass.last}</h3>
        <p>{pass.cycle} {pass.year} · HackPrinceton</p>
        <p>Show this same QR code at arrival and each meal. Bring your student ID for arrival check-in.</p>
        <button type="button" onClick={download}>Save QR code</button>
      </> : error ? <><p role="alert">{error}</p><button type="button" onClick={() => setAttempt(a => a + 1)}>Try again</button></> : <p role="status">Loading your pass…</p>}
    </div>
    {pass && <div className="hacker-pass__qr" ref={qr}>
      <QRCodeSVG value={pass.token} size={320} level="M" marginSize={4} title="Your personal HackPrinceton check-in QR code" />
      <p>Keep this code private.</p>
    </div>}
  </section>;
}
